@charset "UTF-8";

/* libs/shared/src/lib/ui/draggable-table/draggable-table.component.scss */
.datatable-super-upper-wrap {
  position: relative;
}
.datatable-super-upper-wrap .col-settings-wrapper {
  cursor: pointer;
  height: 20px;
  left: -15px;
  position: absolute;
  top: 20px;
}
.datatable-super-upper-wrap .column-settings-wrapper {
  position: absolute;
  z-index: 3;
  border: 1px solid grey;
  padding: 15px;
  background: white;
  min-width: 300px;
  box-shadow: 1px 0px 14px 0px rgba(0, 0, 0, 0.3);
}
.datatable-super-upper-wrap .datatable-upper-wrap {
  max-height: 75vh;
  overflow: visible;
  z-index: 2;
  position: relative;
}
.datatable-super-upper-wrap .datatable-upper-wrap .edit-button-wrapper {
  position: absolute;
}
.datatable-super-upper-wrap .datatable-upper-wrap .save-button {
  position: absolute;
  right: 30px;
  top: 2px;
}
.ngx-datatable.material {
  box-shadow: none;
}
:host ::ng-deep .datatable-row-odd {
  background-color: #f0f4f8;
}
:host ::ng-deep .datatable-row-even {
  background-color: #ffffff;
}
.grab-btn {
  cursor: grab;
}
.grab-btn:active {
  cursor: grabbing;
}
.action-list-custom {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: var(--space-sm);
}
.action-list-custom .action-item {
  position: relative;
}
.action-list-custom .btn-action {
  border: none;
  border-radius: var(--radius-md);
  min-width: 24px;
  height: 24px;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  box-shadow: var(--shadow-sm);
  transition: var(--transition-fast);
  background: var(--primary-color);
}
.action-list-custom .btn-action:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
  background: var(--primary-color-hover);
}
.action-list-custom .btn-action:active {
  transform: translateY(0);
  box-shadow: var(--shadow-sm);
}
.action-list-custom .btn-action:has(i.fa-trash-alt),
.action-list-custom .btn-action:has(i.fa-trash) {
  background: var(--error-red);
}
.action-list-custom .btn-action:has(i.fa-trash-alt):hover,
.action-list-custom .btn-action:has(i.fa-trash):hover {
  background: var(--error-red-hover);
}
.action-list-custom .btn-action.save-button,
.action-list-custom .btn-action:has(i.fa-check) {
  background: var(--success-green);
}
.action-list-custom .btn-action.save-button:hover,
.action-list-custom .btn-action:has(i.fa-check):hover {
  background: var(--success-green-hover);
}
/*# sourceMappingURL=draggable-table.component.css.map */
